import { ActivityType } from '.';

export class SurveyActivityListing
{
    constructor(
        public id:string,
        public title:string,
        public activityType:ActivityType,
        public start:Date,
        public end:Date,
        public actionPlanCount:number,
        public survey:{
            surveyId:string,
            start:Date,
            end:Date,
            questionCount:number,
            answerCount:number
        } | null
    ){}
}
